<template>
  <div class="g-live"></div>
</template>
<script>
import global from "../../utils/Global";

var _godsee = null;
var live_sn = null;
var live_channel_no = null;
var player = null;

export default {
  data() {
    return {
      repeatTimes: 0,
      url: null,
      key: null,
      playData: null,
      flvType: null,
      flvUrl: null,
      _godsee: null,
      live_sn: null,
      live_channel_no: null,
      player: null,
      containerId: ""
    };
  },
  mounted() {},
  methods: {
    publish(d, flvUrl) {
      this.flvUrl = flvUrl;
      this.containerId = d.containerId;
      return new Promise(async (resole, reject) => {
        if (!_godsee || d.play_info.vcloud_appid) {
          await this.initSDK(d).catch(e => {
            reject(e);
          });
        }
        live_sn = d.device_info.device_sn;
        if (
          d.device_info.box_sn &&
          d.device_info.box_sn != "" &&
          d.device_info.box_sn != "undefined"
        ) {
          live_sn = d.device_info.box_sn;
        }
        live_channel_no = parseInt(d.device_info.channel_id);
        var _data = {
          sn: live_sn,
          token: "",
          channel_no: live_channel_no,
          bitrate: 1,
          longconnect: "tcp",
          product_id: d.play_info.vcloud_productid,
          authorization: d.play_info.vcloud_authorization,
          randNum: d.play_info.vcloud_auth_random_num,
          authTime: d.play_info.vcloud_auth_time
        };

        if (this.flvUrl) {
          this.rePlay();
        } else {
          _godsee.startLive(_data);
        }
      });
    },
    initSDK(d) {
      var that = this;
      return new Promise((resole, reject) => {
        if (_godsee) {
          console.log("_godsee init", _godsee);
          resole();
          return;
        }
        var option = {
          userId: "360" + Math.floor(Math.random() * 100000 + 10000000), //**** userId中不能包含下划线(_)
          serviceAppId: d.play_info.vcloud_appid,
          serviceName: d.play_info.vcloud_sname,
          domain: "https://flvmonitor.iot.360.cn",
          online: 0,
          log: 2
        };
        var loglevel = global.getCookie("player_log_level_sdk");
        if (
          loglevel &&
          loglevel != "" &&
          loglevel != "false" &&
          loglevel != "0"
        ) {
          option.log = 2;
        } else {
          option.log = 0;
        }
        _godsee = window.Signalling(option);

        var TOB_STATUS = _godsee.CONFIG_STATUS;
        //侦听SDK事件
        _godsee.on(TOB_STATUS.status, data => {
          if (!data || !data.type) {
            return;
          }
          switch (data.type) {
            case TOB_STATUS.type.connectStatus:
              //长连状态
              if (
                data.param.newVal == "connected" &&
                data.param.type == "websocket"
              ) {
                console.log("data.param", data.param);
                resole();
                //侦听到此状态，表示长连连接成功，之后进行开流等操作
                //TODO: 业务流程
                //准备就绪，开始获取秘钥
                //开流并建立心跳
              }
              break;
            case TOB_STATUS.type.disconnect:
              if (data && data.param && data.param.type == "tcp") {
                console.log("disconnect", data);
                that.$emit("disconnect", data);
              }
              //TODO:长连断开，尝试重连或销毁
              break;
            case TOB_STATUS.type.recordTimeline:
              //请求卡录时间轴结果
              //时间轴结果保存在【data.param.maskArray】中
              let list = data.param.maskArray;
              timelines = [];
              for (let i = 0; i < list.length; i++) {
                let t = list[i];
                let s = parseFloat(t.start);
                let e = parseFloat(t.duration);
                timelines.push({ start: s, end: e });
              }
              break;
            case TOB_STATUS.type.recordSeek:
              //获取卡录数据后，seek到某一个时间段开始播放
              break;
            case TOB_STATUS.type.recordSpeed:
              //卡录倍速设置成功
              break;
            case TOB_STATUS.type.setDevice:
              break;
            case TOB_STATUS.type.relaySuccess:
              //直播或卡录的开流成功
              break;
            case TOB_STATUS.type.pubStream:
              //固件有推流
              var sn = data.param.sn;
              var type = data.param.type;
              var channel_no = data.param.channel_no;
              console.log("TOB_STATUS.type.pubStream");
              console.log(`开流成功!sn: ${sn},  channel_: ${channel_no}`);
              that.streamPubSuccess(sn, channel_no);
              break;
            case TOB_STATUS.type.relayError:
              //直播或卡录的开流失败
              var sn = data.param.sn;
              var channel_no = data.param.channel_no;
              console.log("relayError", data.param);
              if (!sn) {
                return;
              }
              console.error("开流失败，SN：" + sn + "_通道号：" + channel_no);
              break;
            case TOB_STATUS.type.licenseError:
              var sn = data.param.sn;
              var channel_no = data.param.channel_no;
              //license认证失败,开流失败
              reject("license认证失败,开流失败");
              break;
            case TOB_STATUS.type.error:
              console.log("error", data.param);
              var sn = data.param.sn;
              if (parseInt(data.param.errno) == 1000001) {
                // that.sendStreamError(sn, null, 1000001);
                reject(data.param.msg);
              } else {
                var channel_no = data.param.channel_no;
                console.error(
                  data.param.msg + "，SN：" + sn + "_通道号：" + channel_no
                );
                reject(
                  data.param.msg + "，SN：" + sn + "_通道号：" + channel_no
                );
              }
              if (that.flvUrl) {
                that.$emit("flvReconnection");
              }
              break;
          }
        });
      });
    },
    streamPubSuccess(sn, channel_no) {
      var param = {
        sn: sn, //设备sn
        channelno: channel_no, //通道号:与消息通道必须一致
        resolution: 1 //清晰度 01：超清，02：高清，03标清
      };
      var url = _godsee.getPlayUrl(param);
      this.rePlay();

      // getFlvVcodecByUrl(url).then((vcodec) => {
      //   // vcodec 可能返回的值有：'Unknown'、'NotFlv'、'H264'、'H265'
      //   console.log("视频编码格式:", vcodec);
      //   this.flvType = vcodec.vcode;
      //   this.rePlay();
      //   if (!isShowTip) {
      //     $(".g-live-start").show();
      //     $(".g-live-start").off("click");
      //     $(".g-live-start").click(() => {
      //       isShowTip = true;
      //       if(player)
      //       {
      //         if(this.flvType == 'H265')
      //         {
      //           player.play().then(()=>{

      //           });
      //         }
      //         else
      //         {
      //           player.play();
      //         }
      //       }
      //       console.log("开始播放 click");
      //       $(".g-live-start").hide();
      //     });
      //   } else {
      //     console.log("开始播放 auto");
      //     if(player)
      //     {
      //       if(this.flvType == 'H265')
      //         {
      //           player.play().then(()=>{

      //           });
      //         }
      //         else
      //         {
      //           player.play();
      //         }
      //     }
      //   }
      // });
    },
    initQhwwPlayer(url, vcode, sn, channel_no) {
      this.containerId = "g-live-con";
      var playerData = {
        container: `#${this.containerId}`,
        isLive: true,
        keyType: 0,
        volume: 1,
        renderType: "all",
        autoplay: true,
        minDecoderBufferSize: 131072,
        waitingYuvNum: 1,
        waitingPcmDur: 50,
        waitingProbation: 500,
        delayTimeLimit: 0,
        lowpassFrequencyVal: 4500,
        rtwPlaybackRate: 1,
        maxPlaybackRate: 2,
        yuvRenderDelay: -20,
        resample: 1
      };
      if (url) {
        playerData.src = url;
      } else {
        playerData.src = this.getPlayUrlByParam(sn, channel_no);
      }
      var loglevel = global.getCookie("player_log_level_live");
      if (
        loglevel &&
        loglevel != "" &&
        loglevel != "false" &&
        loglevel != "0"
      ) {
        playerData.logLevel = 2;
      } else {
        playerData.logLevel = 0;
      }
      this.playData = JSON.parse(JSON.stringify(playerData));
      var param = this.$route.query.param;
      if (param == "qhww") {
        player = new window.WebPlayer(playerData);
      } else {
        // if (vcode == "H265") {
        console.log("初始化播放器: QhwwPlayer");
        player = new window.WebPlayer(playerData);
        // } else {
        //   console.log("初始化播放器: flvPlayer");
        //   player = flvjs.createPlayer(playerData);
        // }
      }

      player.sn = sn;
      player.channel_no = channel_no;
      player.cont_Id = `${this.containerId}`;

      player.on("play", e => {
        this.$parent.seeClassBegin();
      });
      player.on("error", e => {
        console.log("【播放器】播放异常，error ", e);
        if (this.flvUrl) {
          return this.rePlay();
        }
        // alert('设备：' + sn + '异常，未能获取直播数据');
        if (e && e.target) {
          var sn = e.target.sn;
          var channel_no = e.target.channel_no;
          // that.sendStreamError(sn, channel_no);
        }
        this.$emit("error", e, "live");
      });
      player.on("ended", e => {
        var sn = e.target.sn;
        var channel_no = e.target.channel_no;
        var retry = e.retry;
        if (!retry) {
          // that.sendStreamError(sn, channel_no);
          console.log(
            "--== media source ended, normally means server stop push stream ==--",
            e
          );
        }
      });
    },
    initVCloudPlayer(url, vcode, sn, channel_no) {
      let uid = "360user_yijiang",
        cid;
      if (global && global.userInfo) {
        uid = global.userInfo.userName;
        cid = global.userInfo.qid;
      }
      console.log(`打点信息 uid:${uid},bid:yijiang,cid:${cid}`);
      var playerData = {
        uid,
        bid: "yijiang",
        pid: "web",
        cid,
        playerType: 0,
        container: `${this.containerId}`,
        isLive: true,
        volume: 1,
        autoplay: true,
        mediaData: {
          type: "flvjs"
        },
        src: url,
        ableClick: false
      };
      if (url) {
        playerData.src = url;
      } else {
        playerData.src = this.getPlayUrlByParam(sn, channel_no);
      }
      var loglevel = global.getCookie("player_log_level_live");
      if (
        loglevel &&
        loglevel != "" &&
        loglevel != "false" &&
        loglevel != "0"
      ) {
        playerData.logLevel = 2;
      } else {
        playerData.logLevel = 0;
      }
      this.playData = JSON.parse(JSON.stringify(playerData));
      player = new VCloudPlayer();
      setTimeout(() => {
        player.createPlayer(playerData).then(() => {
          player.play();
        });
      }, 1000);

      player.sn = sn;
      player.channel_no = channel_no;
      player.cont_Id = `${this.containerId}`;

      player.on("play", e => {
        this.$parent.seeClassBegin();
      });
      player.on("error", e => {
        console.log("【播放器】播放异常，error ", e);
        if (this.flvUrl) {
          return this.rePlay();
        }
        // alert('设备：' + sn + '异常，未能获取直播数据');
        if (e && e.target) {
          var sn = e.target.sn;
          var channel_no = e.target.channel_no;
          // that.sendStreamError(sn, channel_no);
        }
        this.$emit("error", e, "live");
      });
      player.on("ended", e => {
        console.log(" ended======> ", e);
        var sn = e.target.sn;
        var channel_no = e.target.channel_no;
        var retry = e.retry;
        if (!retry) {
          // that.sendStreamError(sn, channel_no);
          console.log(
            "--== media source ended, normally means server stop push stream ==--",
            e
          );
        }
      });
    },
    rePlay() {
      var url = "";
      if (player) {
        player.destroy();
      }
      // player = null;
      var param = {
        sn: live_sn, //设备sn
        channelno: live_channel_no, //通道号:与消息通道必须一致
        resolution: 1 //清晰度 01：超清，02：高清，03标清
      };
      if (this.flvUrl) {
        url = this.flvUrl;
      } else {
        url = _godsee.getPlayUrl(param);
      }

      this.initQhwwPlayer(url, this.flvType, live_sn, live_channel_no);
      // this.initVCloudPlayer(
      //   url,
      //   this.flvType,
      //   live_sn,
      //   live_channel_no
      // );
    },

    getPlayerStatus() {
      if (player && $(`#${this.containerId}`).html() == "") {
        player.destroy();
        player = null;
        return true;
      }
      return false;
    },
    stop() {
      this.flvUrl = null;
      if (live_channel_no && live_sn) {
        if (_godsee) {
          _godsee.stopPlay(live_sn, live_channel_no);
        }
      }
      live_channel_no = null;
      live_sn = null;
      if (player) {
        player.destroy();
        player = null;
      }
    },
    checkPlayReady() {
      // if (!isShowTip) {
      //   $(".g-live-start").show();
      //   $(".g-live-start").off("click");
      //   $(".g-live-start").click(() => {
      //     isShowTip = true;
      //     console.log("开始播放 click");

      //     $(".g-live-start").hide();
      //     this.$emit("playReady");
      //   });
      // } else {
      console.log("开始播放 playReady");
      this.$emit("playReady");
      // }
    },
    record(url, key) {
      $(".g-live-start").hide();
      if (player) {
        player.destroy();
        player = null;
      }
      this.initRecordPlayer(url);
      this.url = url;
      // if (key) {
      //   player[player.__mmk].setPlayerProps("key", key);
      // }
      // setTimeout(() => {
      //   if (player) {
      //     // player.play().then(() => { });
      //     player.play();
      //   }
      // }, 50);
    },
    live(url, key) {
      var isRelay = url.slice(0, 5) == "ws://";
      if (!player) {
        this.initPlayer(isRelay, url);
      }
      this.url = url;
      if (!isRelay) {
        getFlvVcodecByUrl(url).then(vcodec => {
          // vcodec 可能返回的值有：'Unknown'、'NotFlv'、'H264'、'H265'
          console.log("视频编码格式:" + vcodec);
        });
      }

      player.src = url;
      if (key) {
        if (isRelay) {
          player[player.__mmk].setPlayerProps("relayKey", key);
        } else {
          player[player.__mmk].setPlayerProps("key", key);
        }
      }
      setTimeout(() => {
        if (player) {
          player.play().then(() => {});
        }
      }, 50);
    },
    resize(show, size) {},
    //初始化直播播放器
    initRecordPlayer1(url) {
      var _t = this;
      if (player) {
        return;
      }
      console.log("初始化直播播放器");
      var playerData = {
        container: `#${this.containerId}`,
        isLive: false,
        isHLS: true,
        keyType: 0,
        volume: 1,
        maxVolume: 2,
        logLevel: 0,
        autoplay: true,
        minDecoderBufferSize: 64 * 1024,
        src: url,
        CDNType: 0
      };
      if (!window.WebPlayer) {
        return;
      }
      player = new window.WebPlayer(playerData);
      player.on("error", function(e) {
        if (e && e.data) {
          _t.$emit("error", e.data, "record");
        } else {
          _t.$emit("error", e, "record");
        }
      });
    },
    //初始化回看播放器
    initRecordPlayer(url) {
      var _t = this;
      this.containerId = "g-live-con";
      if (player) {
        return;
      }
      console.log("初始化回看播放器");
      var playerData = {
        playerType: 0,
        container: `${this.containerId}`,
        isLive: false,
        isHLS: true,
        mediaData: {
          type: "hls"
        },
        // keyType: 0,
        volume: 1,
        maxVolume: 2,
        logLevel: 0,
        autoplay: true,
        minDecoderBufferSize: 64 * 1024,
        src: url,
        CDNType: 0
      };
      if (!window.VCloudPlayer) {
        return;
      }
      player = new VCloudPlayer();
      player.createPlayer(playerData).then(() => {
        player.play();
        player.on("HLS_ERROR", function(e) {
          if (
            e &&
            e.data &&
            e.data.errorResponse &&
            e.data.errorResponse.data
          ) {
            let data = JSON.parse(e.data.errorResponse.data);
            if (data && data.errmsg) {
              return _t.$emit("error", data.errmsg, "record");
            }
          } else if (
            e &&
            e.data &&
            e.data.errorDetails === "manifestParsingError"
          ) {
            return _t.$emit(
              "error",
              "当前媒体资源的 m3u8 内容解析失败。",
              "record"
            );
          }
          // _t.$emit("error", '当前媒体资源的 m3u8 内容解析失败。', 'record');
          // if (e && e.data) {
          //   _t.$emit("error", e.data, 'record');
          // }
          // else {
          //   _t.$emit("error", e, 'record');
          // }
        });
      });
    },
    initPlayer(isRelay) {
      if (player) {
        return;
      }
      console.log("初始化直播播放器");
      var playerData = {
        container: `#${this.containerId}`,
        isLive: true,
        isHLS: false,
        keyType: 0,
        volume: 1,
        maxVolume: 2,
        logLevel: 0,
        autoplay: true,
        minDecoderBufferSize: 256 * 1024,
        waitingYuvNum: 1,
        waitingPcmDur: 50,
        waitingProbation: 500,
        delayTimeLimit: 100000,
        lowpassFrequencyVal: 4500,
        rtwPlaybackRate: 1,
        maxPlaybackRate: 1,
        yuvRenderDelay: -20,
        resample: 1
      };
      var loglevel = global.getCookie("player_log_level_sdk");
      if (
        loglevel &&
        loglevel != "" &&
        loglevel != "false" &&
        loglevel != "0"
      ) {
        playerData.log = 2;
      } else {
        playerData.log = 0;
      }
      if (isRelay) {
        playerData.isRelay = true;
      }
      if (!window.WebPlayer) {
        this.$emit("error", 1);
        return;
      }

      player = new window.WebPlayer(playerData);
      var that = this;
      player.on("error", function(e) {
        if (that.repeatTimes >= 3) {
          that.stop(true);
          that.$emit("error");
          return;
        }
        if (e.data == "websocket closed") {
          return;
        }
        that.stop();
        that.live(that.url, that.key);
        that.repeatTimes++;
      });
    }
  },
  components: {}
};
</script>

<style>
.g-live {
  width: 100%;
  height: 100%;
  position: relative;
}

#g-live-con {
  position: relative;
  z-index: 2;
  width: 100% !important;
  height: 100% !important;
}

.qhww-player-container {
  width: 100% !important;
  height: 100% !important;
  overflow: hidden;
  background: #212427 url(https://p3.ssl.qhimg.com/t01d760a4fcf790ee34.png)
    center no-repeat !important;
  background-size: 286px 62px;
}

.qhww-player-container .qhww-canvas-wrap {
  width: 100% !important;
  height: 100% !important;
  display: flex;
  align-items: center;
  justify-content: center;
}

.qhww-player-container .qhww-canvas-wrap canvas {
  width: auto !important;
  height: auto !important;
  max-width: 100% !important;
  max-height: 100% !important;
}

.qhww-rate-box {
  /* display: none; */
}

.qhww-player-container .qhww-controlbar .qhww-btn-pause {
  /* display: none; */
}

.qhww-player-container .qhww-controlbar .qhww-btn-stop {
  /* display: none; */
}

.g-live-start {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 10;
  left: 0;
  top: 0;
  cursor: pointer;
  display: none;
  background: #303030 url(https://p4.ssl.qhimg.com/t01ae1148cfc4c15adc.jpg)
    no-repeat center;
  background-size: auto 100%;
}

.g-live-start-logo {
  position: absolute;
  z-index: 12;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  /* margin-left: 385px;
  margin-top: 260px; */
  background: url(https://p3.ssl.qhimg.com/t01d2f1856b2c0fa3e7.png) no-repeat
    center;
  background-size: 100px 100px;
}

.size-big .g-live-start-btn {
  margin-top: 540px;
}

.size-normal .g-live-start-btn {
  margin-top: 450px;
}

.size-small .g-live-start-btn {
  margin-top: 380px;
}

.g-live-start-btn {
  position: absolute;
  z-index: 11;
  width: 100%;
  height: 40px;
  text-align: center;
  line-height: 40px;
  margin-top: 380px;
  border-radius: 4px;
  /* border: solid 1px #1890ff; */
  text-align: center;
  color: #fff;
  font-size: 18px;
  transition: 0.3s opacity;
}

.g-live-start:hover .g-live-start-btn {
  /* color: #1890ff; */
}

.g-live-start:hover .g-live-start-logo {
  background: url(https://p4.ssl.qhimg.com/t015599305223aa7d68.png) no-repeat
    center;
  background-size: 100px 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/page/device/live.vue